import { FC } from 'react';

const AutomationThenBlock: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <div className="flex flex-col gap-4">{children}</div>;
};

export { AutomationThenBlock };
